export const SCHOOL_CONTACT_FORM_I18N_ENTRIES = {
  school_contact_form_Data1: {
    es: '<p>Formulario de contacto</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data2: {
    es: '<p>Nombre del centro</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data3: {
    es: '<p>Nombre de persona responsable</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data4: {
    es: '<p>Cargo de persona responsable</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data5: {
    es: '<p>Correo electrónico</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data6: {
    es: '<p>Teléfono</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data7: {
    es: '<p>He leído y acepto las <a href="/legal" target="_blank">condiciones de uso</a></p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data8: {
    es: '<p>Acepto recibir comunicaciones comerciales relacionadas con la entidad <span class="i18n-bold">(Smart)Makings</span> a través de correo electrónico o medios electrónicos, incluído teléfono.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data9: {
    es: '<p>Enviar consulta</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data10: {
    es: '<p>Gracias por tu solicitud.</p><p>Contactaremos</p><p>contigo lo antes posible.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data11: {
    es: '<p>Cerrar</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data12: {
    es: '<p>Campo obligatorio*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data13: {
    es: '<p>Correo introducido incorrecto*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data14: {
    es: '<p>Teléfono introducido incorrecto*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data15: {
    es: '<p>Acepta las condiciones*</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data16: {
    es: '<p>Nombre de empresa</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data17: {
    es: '<p>Parece que algo ha fallado.</p><p>Inténtalo de nuevo más tarde.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  school_contact_form_Data18: {
    es: '<p>Reintentar</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
};
